import { IUpdateStatusColetaPrecoUseCase } from "../../../presentation/useCases/update/update_status_coleta_preco_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * UpdateStatusColetaPrecoUseCase
 */

export class UpdateStatusColetaPrecoUseCase implements IUpdateStatusColetaPrecoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateStatusColetaPreco(
    idColetaPreco: number,
    status: number,
  ): Promise<void> {
    await this.repository.updateStatusColetaPreco(idColetaPreco, status);
  }
}
